import { useTranslation } from "@impero-com/common/utils/i18n";

import { ExportModal, ExportModalOption } from "components/modals/ExportModal";

export type ControlActivityExportModalSubmitType =
    | "ControlActivitiesWithAnswers"
    | "ControlActivitiesWithoutAnswers"
    | "ControlActivityAttachments";

interface ControlActivityExportModalProps {
    onSubmit: (type: ControlActivityExportModalSubmitType) => void;
    onClose: () => void;
    open: boolean;
    loading: boolean;
}

export function ControlActivityExportModal({
    onSubmit,
    onClose,
    open,
    loading,
}: ControlActivityExportModalProps) {
    const { t } = useTranslation();

    const options: ExportModalOption<ControlActivityExportModalSubmitType>[] = [
        {
            value: "ControlActivitiesWithoutAnswers",
            label: t("ControlResult_ExportOptions_WithoutAnswers"),
        },
        {
            value: "ControlActivitiesWithAnswers",
            label: t("ControlResult_ExportOptions_WithAnswers"),
        },
        {
            value: "ControlActivityAttachments",
            label: t("ControlResult_ExportOptions_Attachments"),
        },
    ];

    return (
        <ExportModal
            onSubmit={onSubmit}
            onClose={onClose}
            open={open}
            loading={loading}
            title={t("ControlResult_ExportOptions_Title")}
            options={options}
            defaultValue="ControlActivitiesWithoutAnswers"
        />
    );
}
